<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="card">
            <div class="tab-content">
                <div class="tab-pane active">
                    <div class="body">
                        <div class="row clearfix">
                            <div class="col-lg-8 col-md-12">
                                <div class="form-group">
                                    <label class="tw-text-xl">
                                        ออเดอร์ {{ order.reference }}
                                    </label>
                                    <div>
                                        <div class="tw-flex order-form__group">
                                            <div>ชื่อผู้สั่ง</div>
                                            <div>{{ order.name }}</div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>เบอร์โทร</div>
                                            <div>{{ order.phone }}</div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>อีเมล</div>
                                            <div>{{ order.email }}</div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>ที่อยู่</div>
                                            <div>
                                                {{ order.address }}
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>จัดส่งโดย</div>
                                            <div>
                                                {{ order.transport }}
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>วัน-เวลา</div>
                                            <div>
                                                {{
                                                    dateFormat(order.created_at)
                                                }}
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>สถานะ</div>
                                            <div>
                                                {{ orderStatus }}
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>เลขขนส่ง</div>
                                            <div>
                                                {{
                                                    order.tracking_number || "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>ลิงค์บิล</div>
                                            <div>
                                                {{ linkBill }}
                                                <i
                                                    :class="
                                                        `fa fa-clipboard ml-2 animate_duration ${
                                                            text_copy ==
                                                            'คัดลอกแล้ว'
                                                                ? 'headShake'
                                                                : ''
                                                        }`
                                                    "
                                                    v-clipboard:copy="linkBill"
                                                    v-clipboard:success="onCopy"
                                                    v-clipboard:error="onError"
                                                >
                                                </i>
                                            </div>
                                        </div>
                                        <div class="tw-flex order-form__group">
                                            <div>หมายเหตุ</div>
                                            <div style="white-space: normal; text-wrap: wrap; overflow-wrap: anywhere;">
                                                {{ order.remark || "-" }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label
                                        for="order-status"
                                        class="tw-text-xl"
                                    >
                                        สถานะ
                                    </label>
                                    <select
                                        name="order-status"
                                        class="form-control"
                                        v-model="order.status"
                                        :disabled="
                                            order.status == 'cancel' ||
                                                order.status == 'done' ||
                                                    order.status == 'cancelled'
                                        "
                                        @change="handleChangeStatus()"
                                    >
                                        <option value="pending">
                                            รอการตรวจสอบ
                                        </option>
                                        <option value="cancel">
                                            ยกเลิก
                                        </option>
                                        <option value="approve">
                                            รอส่งสินค้า
                                        </option>
                                        <option value="done" hidden>
                                            ส่งแล้ว
                                        </option>
                                        <option value="cancelled" hidden>
                                            ยกเลิกแล้ว
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="order.status === 'cancel'"
                                >
                                    <label
                                        for="order-status"
                                        class="tw-text-xl"
                                    >
                                        เหตุผลการยกเลิกออเดอร์
                                    </label>
                                    <div>
                                        <textarea
                                            v-model="order.reason_cancel"
                                            class="form-control"
                                            rows="5"
                                            placeholder="กรุณากรอกเหตุผลการยกเลิกออเดอร์"
                                        ></textarea>
                                        <div
                                            class="tw-mt-2 tw-w-full text-right"
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-success"
                                                @click="confirmCancel()"
                                            >
                                                ยืนยันการยกเลิก
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="order.status === 'cancelled'"
                                >
                                    <label
                                    for="order-status"
                                    class="tw-text-xl"
                                    >
                                        เหตุผลการยกเลิกออเดอร์
                                    </label>
                                    <div>
                                        {{ order.reason_cancel }}
                                    </div>
                                </div>
                                <div
                                    class="form-group tw-p-4 border tw-rounded"
                                    v-if="order.status == 'approve'"
                                >
                                    <label
                                        for="order-status"
                                        class="tw-text-lg"
                                    >
                                        เลขขนส่ง
                                    </label>
                                    <input
                                            type="text"
                                            class="form-control"
                                            placeholder="กรุณากรอกเลขขนส่ง"
                                            v-model="form.tracking_number"
                                    />
                                    <label
                                        for="order-remark"
                                        class="tw-text-lg mt-2"
                                        
                                    >
                                        หมายเหตุ
                                    </label>
                                    <textarea
                                        type="text"
                                        class="form-control"
                                        style="resize: vertical; min-height: 125px;"
                                        placeholder="หมายเหตุถึงลูกค้า (ไม่บังคับ)"
                                        v-model="form.remark"
                                    >
                                    </textarea>

                                    <div class="tw-flex tw-justify-end tw-mt-2">
                                    <button
                                        class="btn btn-sm btn-success"
                                        @click="addTrackingNumber()"
                                    >
                                        ยืนยัน
                                    </button>
                                    </div>

                                </div>

                            </div>
                            <div class="col-lg-4 col-md-12">
                                <!-- slip -->
                                <div class="tw-flex tw-flex-col">
                                    <div class="tw-font-bold tw-mb-2">
                                        หลักฐานการโอนเงิน
                                    </div>
                                    <div v-if="!order.paypal_order_id">
                                        <img 
                                            class="image_slip"
                                            :src="order.image_url"
                                            alt=""
                                        />
                                    </div>
                                   <div v-else class="border tw-rounded text-center tw-justify-center p-2">
                                       <div>
                                            <i class="text-center fa fa-3x fa-check"></i>
                                       </div>
                                       <div>
                                            ชำระเงินผ่าน Paypal
                                       </div>
                                       <div>
                                            {{ paypalOrder }}
                                       </div>
                                       <!-- <div>
                                            {{ paypalOrder ? paypalOrder.payments.captures[0].amount.currency_code : '' }} {{ paypalOrder ? paypalOrder.payments.captures[0].amount.value : ''}} 
                                       </div>
                                       <div class="text-secondary text-sm">
                                            {{ paypalOrder ? paypalOrder.payments.captures[0].create_time : '' }}
                                       </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row tw-mt-5 ">
                            <div class="col-lg-8 col-12">
                                <div class="card mt-3 order-border">
                                    <div class="card-header tw-bg-white">
                                        <h5 class="m-0">รายละเอียดสินค้า</h5>
                                    </div>
                                    <div class="card-body">
                                        <table
                                            class="table table-sm table-borderless"
                                        >
                                            <tbody>
                                                <tr
                                                    v-for="(item,
                                                    index) in order.order_products"
                                                    :key="index"
                                                >
                                                    <td>
                                                        <div
                                                            class="form-group tw-flex "
                                                        >
                                                            <div
                                                                class="image-product-cart pr-0 tw-mr-5"
                                                            >
                                                                <img
                                                                    :src="
                                                                        `${item.product.image_url}`
                                                                    "
                                                                    class="cart-product__image"
                                                                />
                                                            </div>
                                                            <div>
                                                                <p
                                                                    class="tw-text-sm"
                                                                >
                                                                    {{
                                                                        item.name
                                                                    }}
                                                                </p>
                                                                <p
                                                                    class="tw-font-bold"
                                                                >
                                                                    {{ currency ? currency.symbol : '' }} {{
                                                                        item.price_unit
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{
                                                            `x ${item.quantity}`
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            `${ currency ? currency.symbol : ''} ${item.price_total}`
                                                        }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card tw-rounded-none mb-3">
                                    <div
                                        class="card-header tw-bg-white tw-border-none pb-0"
                                    >
                                        <span class="tw-font-bold tw-text-lg"
                                            >สรุปยอดสั่งซื้อ</span
                                        >
                                    </div>
                                    <div class="card-body">
                                        <div class="form-check row">
                                            <div
                                                class="tw-flex tw-justify-between mx-3"
                                            >
                                                <div class="col-md-6">
                                                    <p
                                                        class="mb-2 tw-font-thin"
                                                    >
                                                        ยอดรวมสินค้า
                                                    </p>
                                                </div>
                                                <div
                                                    class="col-md-6 tw-flex tw-flex-row-reverse"
                                                >
                                                    <p
                                                        class="mb-2 tw-font-thin"
                                                    >
                                                        {{ currency ? currency.symbol : '' }} {{
                                                            order.price_product
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-check row">
                                            <div
                                                class="tw-flex tw-justify-between mx-3"
                                            >
                                                <div class="col-md-6">
                                                    <p
                                                        class="mb-2 tw-font-thin"
                                                    >
                                                        ค่าจัดส่ง
                                                    </p>
                                                </div>
                                                <div
                                                    class="col-md-6 tw-flex tw-flex-row-reverse"
                                                >
                                                    <p
                                                        class="mb-2 tw-font-thin"
                                                    >
                                                        {{ currency ? currency.symbol : '' }} {{
                                                            order.price_transport
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="my-1" />
                                        <div class="form-check row">
                                            <div
                                                class="tw-flex tw-justify-between mx-3"
                                            >
                                                <div class="col-md-6">
                                                    <p
                                                        class="mb-2 tw-font-normal"
                                                    >
                                                        ยอดราคารวม
                                                    </p>
                                                </div>
                                                <div
                                                    class="col-md-6 tw-flex tw-flex-row-reverse"
                                                >
                                                    <p
                                                        class="mb-2 tw-font-normal"
                                                    >
                                                        {{ currency ? currency.symbol : '' }} {{ order.price_total }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="body">
                        <div class="tw-w-full text-right">
                            <button
                                type="button"
                                class="btn btn-sm btn-success"
                                @click="back()"
                            >
                                ยืนยัน
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-default tw-ml-1"
                                @click="back()"
                            >
                                ย้อนกลับ
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: ["orderId", "shop", "base_url"],
    data() {
        return {
            api_url: this.base_url || "",
            form: {},
            loading: false,
            order: {},
            paypalOrder: {},
            text_copy: "คัดลอก",
            currency: null,
        };
    },
    mounted() {
        this.getData();
        this.getPaypalData();
        this.getCurrency();

    },
    watch: {
        orderId(val) {
            this.getData();
            this.getPaypalData();
        }
    },
    computed: {
        linkBill() {
            let link = "";
            const protocal = window.location.protocol;
            const hostname = window.location.hostname;
            if (this.order.sale_pages?.slug) {
                const path = `${this.order.sale_pages.slug}/status-form/${this.order.order_slug}`;
                link = `${protocal}//${hostname}/${path}`;
            }
            return link;
        },
        orderStatus() {
            let rs = "";
            if (this.order.status == "pending") {
                rs = "รอการตรวจสอบ";
            } else if (this.order.status == "cancel") {
                rs = "ยกเลิก";
            } else if (this.order.status == "approve") {
                rs = "รอส่งสินค้า";
            } else if (this.order.status == "done") {
                rs = "ส่งแล้ว";
            }
            return rs;
        }
    },
    methods: {
        back() {
            this.$emit("onClose", "close");
        },
        onCopy: function(e) {
            this.text_copy = "คัดลอกแล้ว";
            this.copiedText = e.text;
        },
        onError: function(e) {
            console.log("Failed to copy texts");
        },
        dateFormat(date) {
            return moment(date).format("DD/MM/YYYY h:mm:ss a") || "";
        },
        handleChangeStatus() {
            if (this.order.status !== "cancel") {
                this.changeOrderStatus();
            }
        },
        async changeOrderStatus() {
            this.loading = true;
            await axios
                .post(
                    `${this.api_url}/ajax/frontend/${this.shop}/order/${this.orderId}/status`,
                    {
                        status: this.order.status,
                        reason_cancel: this.order.reason_cancel
                    }
                )
                .then(res => {
                    this.getData();
                    this.getPaypalData();
                    this.loading = false;
                    window.location.reload();
                })
                .catch(err => {
                    console.log(err.response.data);
                });
        },
        async addTrackingNumber() {
            this.loading = true;
            await axios
                .post(
                    `${this.api_url}/ajax/frontend/${this.shop}/order/${this.orderId}/tracking_number`,
                    {
                        tracking_number: this.form.tracking_number,
                        remark: this.form.remark
                    }
                )
                .then(res => {
                    this.getData();
                    this.getPaypalData();
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        confirmCancel() {
            if (this.order.reason_cancel) {
                this.$swal({
                    icon: "warning",
                    title: "ต้องการยกเลิกออเดอร์ใช่หรือไม่?",
                    text: "เมื่อกดยืนยัน จะไม่สามารถแก้ไขสถานะออเดอร์ได้อีก",
                    confirmButtonText: "ยืนยัน",
                    showCancelButton: true,
                    cancelButtonText: "ยกเลิก",
                    reverseButtons: true
                }).then(result => {
                    if (result.isConfirmed) {
                        this.changeOrderStatus();
                    } else {
                        this.order.status = "pending";
                    }
                });
            } else {
                this.$swal({
                    icon: "error",
                    title: "ขอโทษค่ะ",
                    text: "กรุณากรอกเหตุผลการยกเลิกออเดอร์ก่อนยืนยัน",
                    showConfirmButton: true
                });
            }
        },
        async getPaypalData() {
            this.loading = true;
            await axios
                .get(`${this.api_url}/ajax/frontend/s/${this.shop}/paypal/order/${this.orderId}`)
                .then(res => {
                    this.paypalOrder = res.data.order;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err.response.data);
                    this.loading = false;
                })
        },
        async getData() {
            this.loading = true;
            await axios
                .get(`${this.api_url}/ajax/frontend/order/${this.orderId}`)
                .then(res => {
                    console.log(res.data);
                    this.order = res.data.order;

                    if (this.order.status == "cancel") {
                        this.order.status = "cancelled";
                    }
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        }

    }
};
</script>
<style lang="scss" scoped>
.fa-clipboard {
    cursor: pointer;
}
.order-form__group {
    div:first-child {
        font-weight: 600;
        margin-right: 5px;
        width: 70px;
    }
    div:last-child {
        &::before {
            content: ": ";
            margin-right: 10px;
        }
    }
}
.image_slip {
    width: 300px;
}
.cart-product__image {
    max-height: 60px;
    max-width: 60px;
    width: 100%;
    img {
        @media (min-width: 0px) and (max-width: 992px) {
            width: 100%;
            height: auto;
            max-height: 60px;
            max-width: 60px;
            object-fit: contain;
            max-width: -webkit-fill-available;
        }
        height: 100%;
        max-width: -webkit-fill-available;
    }
}
.order-product__detail {
    max-width: 882px;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: 0px) and (max-width: 992px) {
        padding: 0;
        margin: 0;
        div {
            padding-left: 0;
            padding-right: 0;
        }
    }
}
.order-border {
    border: 1px solid #e0e0e0;
    @media (min-width: 0px) and (max-width: 992px) {
        border: none;
        margin: 0;
    }
}
@keyframes bounce {
    from,
    20%,
    53%,
    to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transform: translate3d(0, 0, 0);
    }

    40%,
    43% {
        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
        transform: translate3d(0, -30px, 0) scaleY(1.1);
    }

    70% {
        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
        transform: translate3d(0, -15px, 0) scaleY(1.05);
    }

    80% {
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transform: translate3d(0, 0, 0) scaleY(0.95);
    }

    90% {
        transform: translate3d(0, -4px, 0) scaleY(1.02);
    }
}

@keyframes headShake {
    0% {
        transform: translateX(0);
    }

    6.5% {
        transform: translateX(-6px) rotateY(-9deg);
    }

    18.5% {
        transform: translateX(5px) rotateY(7deg);
    }

    31.5% {
        transform: translateX(-3px) rotateY(-5deg);
    }

    43.5% {
        transform: translateX(2px) rotateY(3deg);
    }

    50% {
        transform: translateX(0);
    }
}

.headShake {
    animation-timing-function: ease-in-out;
    animation-name: headShake;
}

.animate_duration {
    animation-duration: 1s;
}

.bounce {
    animation-name: bounce;
    transform-origin: center bottom;
}
textarea {
    resize: none;
}
</style>
